<template>
    <div :class="[isFromWx?'icons-c-wx':'icons-c']" @click="handleCollection" data-spm-data="5">
        <div :class="[isCollection?'collection-icon':'no-collection-icon']"/>
        <!-- 微信页样式 -->
        <div class="count" v-if="isFromWx">{{ setCount(collectionCount) || '收藏' }}</div>
        <div class="count" v-else-if="collectionCount">{{ setCount(collectionCount) }}</div>
    </div>
</template>
<script>
import { sendCollection,getInteractionCountApi } from '@/js/article-main/request/api'
import { getUserInfo } from '@/js/request/uisRequest';
import Util from '@/utils/util'

const isTest = Util.getEnvironment() == 'test'

export default {
    name: '',
    props: ['needFetch','collectionData','from'],
    data() {
        return {
            isLogin: false,
            collectionCount: 0, // 收藏数量
            isCollection: false, // 收藏状态
            isSendCollection: false,
            loginHref: '',
        }
    },
    async created() {
        try {
            const res = await getUserInfo()
            if(res.code == 1 && res.data.userId) {
                this.isLogin = true
            }
        } catch (error) {
        }
    },
    mounted() {
        this.getLoginHref()
        if(this.needFetch)this.getInteracitonCount() // 获取评论、点赞、收藏数量
    },
    watch: {
        collectionData: {
            handler: function (newValue, oldValue) {
               this.isCollection = newValue?.isCollection || false
               this.collectionCount = newValue?.collectionCount || 0
               this.handleCollectionCache()
            },
            deep: true
        }
    },
    computed: {
        // 微信页
        isFromWx() {
            return this.from == 'wx'
        }
    },
    methods: {
        // 获取互动数量
        async getInteracitonCount() {
            let res = await getInteractionCountApi()
            if(res.code == 1 && res.data) {
                let countObj = res?.data?.[`mp_${window.cfgs?.newsId}`]
                // 收藏
                this.isCollection = countObj[11]?.optionInfos?.[0]?.operated
                this.collectionCount = countObj[11]?.optionInfos?.[0]?.count
                // 处理收藏缓存
                this.handleCollectionCache()
                
            }
        },
         // 处理收藏缓存
        handleCollectionCache() {
            // 来自登录页 && 点了收藏
            if(localStorage.getItem('collectionArticle') && document.referrer.includes('sohu.com/login')) {
                if(!this.isCollection)this.handleCollection()
            }
            localStorage.removeItem('collectionArticle') 
        },
        setCount(count) {
            let num = "";
            if (999 > count > 0) {
                num = count;
            } else if (count > 999) {
                num = `999+`;
            }
            return num;
        },
        getLoginHref() {
            let env = Util.getEnvironment()
            const loginHost = {
                test: "https://test-m.sohu.com/login?type=1&origin=9",
                pre: "https://pre-m.sohu.com/login?type=1&origin=9",
                prod: "https://m.sohu.com/login?type=1&origin=9",
            }
            this.loginHref = loginHost[env]
        },
        // 收藏
        async handleCollection() {
            if(this.isSendCollection) return
            if(!this.isLogin) {
                if(!this.isCollection)localStorage.setItem('collectionArticle', true);
                window.location.href = `${this.loginHref}&r=${encodeURIComponent(window.location.href)}`
                return
            }
            try {
                this.isSendCollection = true
                const res = await sendCollection(!this.isCollection)
                if(res?.code == 400001) {
                    this.isCollection = !this.isCollection
                    this.collectionCount = this.isCollection ? this.collectionCount + 1 : this.collectionCount - 1
                    if(this.isCollection) {
                        window?.sohuSpm?.sendAction({ acode: 10920 });
                        // TODO:收藏成功提示
                        const jumpHref = isTest ? '//test-m.sohu.com/xchannel/TURBd01EQXlNVEl6' : '//m.sohu.com/xchannel/8001'
                        window.h5_sohu.plugin.api.call('toast',
                        {
                            text: '收藏成功，',
                            richText:  `<a href=${jumpHref} style="color:#FFD100;text-decoration:underline">我的收藏</a>`, 
                            type: 1, 
                            duration: 3000
                        })
                    }else {
                        window?.sohuSpm?.sendAction({ acode: 10921 });
                        // 取消收藏提示
                        window.h5_sohu.plugin.api.call('toast',
                        {
                            text: '已取消收藏',
                            type: undefined, 
                        })
                    }
                }
                this.isSendCollection = false
            } catch (error) {
                this.isSendCollection = false
            }
        
        },
    }
 
}
</script>
<style lang="less" scoped>
.icons-c {
    width: 40px; /*px*/
    height: 40px; /*px*/
    position: relative;
    margin-left: 44px; /*px*/
    .collection-icon {
      width: 40px; /*px*/
      height: 40px; /*px*/
      background: url('../less/images/wap-yellow-collection.png');
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .no-collection-icon {
      width: 40px; /*px*/
      height: 40px; /*px*/
      background: url('../less/images/wap-black-collection.png');
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 0;
    }
    .count {
      position: absolute;
      width: fit-content;
      transform: translate(-40%, -50%);
      height: 26px; /*px*/
      line-height: 26px; /*px*/
      height: 28px; /*px*/
      background: #ffd100;
      border: 2px solid #ffffff; /*px*/
      display: flex;
      align-items: center;
      top: 0px;
      left: 32px; /* px */
      color: #111111;
      font-size: 24px; /* px */
      padding: 0 10px;
      text-align: center;
      border-radius: 13px; /* px */
      box-shadow: 0 0 3px 3px #f2f2f2;
      font-weight: 700;
    }
  }
// 图集页
.comment-footer-album {
    .no-collection-icon {
        background: url('../less/images/icon_collection_line4.png');
        background-size: 100% 100%;
    }
  }
#collectionButton {
    .no-collection-icon {
        background: url('../less/images/icon_video_collection.png');
        background-size: 100% 100%;
    }
}
.icons-c-wx {
    width: 54px; /*px*/
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-left: 26px;/*px*/
    .collection-icon {
        width: 44px; /*px*/
        height: 44px; /*px*/
        background: url('../less/images/collection-wx.png');
        background-size: 100% 100%;
    }
    .no-collection-icon {
        width: 44px; /*px*/
        height: 44px; /*px*/
        background: url('../less/images/un-collection-wx.png');
        background-size: 100% 100%;
    }
    .count {
        margin-top: 4px;/*px*/
        height: 32px; /*px*/
        line-height: 32px; /*px*/
        display: flex;
        align-items: center;
        color: #111111;
        font-size: 24px; /* px */
        font-weight: 400;
    }
}
</style>